<template>
    <el-dialog
        title="更换负责人"
        :visible.sync="directorChangeVisible"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        custom-class="custom-form-dialog custom-allocation-dialog"
    >
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="formLoading">
            <el-form-item label="变更为" prop="salesperson">
                <el-select
                    placeholder="请选择"
                    v-model="formData.salesperson"
                    :remote-method="getUserList"
                    filterable
                    remote
                    reserve-keyword
                >
                    <el-option
                        v-for="(userItem, userIndex) in userList"
                        :key="userItem.uid"
                        :value="userItem.uid"
                        :label="userItem.name"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <template #label>
                    <span class="bold-text">下列客户将被变更负责人</span>
                </template>
                <div class="select-company">
                    <p v-for="(companyItem, companyIndex) in selectedList" :key="companyItem.id">
                        {{ selectedList.length > 1 ? companyIndex + 1 + "." : ""
                        }}{{ companyItem.name && companyItem.name.value }}
                    </p>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>

        <DirectorChangeSync
            :syncChangeTitle="syncChangeTitle"
            :syncChangeType="1"
            :directorChangeSyncVisible.sync="directorChangeSyncVisible"
            v-if="directorChangeSyncVisible"
        />
    </el-dialog>
</template>
<script>
import { GetUserList, UpdateCustomerPrivateSalesperson } from "@/api/index.js";
import DirectorChangeSync from "./director_change_sync.vue";
export default {
    name: "DirectorChange",
    components: { DirectorChangeSync },
    props: {
        directorChangeVisible: {
            type: Boolean,
            default: false,
        },
        selectedList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            dialogVisible: false,
            formLoading: false,
            formData: {
                salesperson: "",
            },
            formRules: {
                salesperson: [{ required: true, message: "请选择", trigger: "change" }],
            },
            userList: [],
            btnDisabled: false,
            syncChangeTitle: "同步变更负责人",
            directorChangeSyncVisible: false,
        };
    },
    mounted() {
        this.getUserList();
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:directorChangeVisible", false);
        },
        handleDialogConfirm() {
            // this.directorChangeSyncVisible = true;
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    this.formLoading = true;
                    this.btnDisabled = true;
                    const customer_ids = this.selectedList.map((item) => item.id);
                    const params = {
                        customer_ids,
                        salesperson: this.formData.salesperson,
                    };
                    UpdateCustomerPrivateSalesperson(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.formLoading = false;
                            this.btnDisabled = false;
                            this.$emit("update:directorChangeVisible", false);
                            this.$emit("updateCallback");
                        } else {
                            this.formLoading = false;
                            this.btnDisabled = false;
                            this.$message.error(res.message);
                        }
                    });
                }
            });
        },
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
    },
};
</script>
<style lang="scss">
.custom-allocation-dialog {
    .el-form {
        .el-form-item__content {
            height: auto;
        }
    }
    .bold-text {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .select-company {
        margin-top: 4px;
        padding: 8px 12px;
        border-radius: 6px;
        background: rgba(247, 248, 250, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        max-height: 236px;
        overflow-y: scroll;
    }
}
</style>
